import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpfeedbackrunner2postPostFeedbackResponseSchema = jsonObject
export type tcpfeedbackrunner2postPostFeedbackResponse = z.infer<typeof tcpfeedbackrunner2postPostFeedbackResponseSchema>
export const tcpfeedbackrunner2postPostFeedbackIdStatusResponseSchema = jsonObject
export type tcpfeedbackrunner2postPostFeedbackIdStatusResponse = z.infer<typeof tcpfeedbackrunner2postPostFeedbackIdStatusResponseSchema>
